import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { IteamState } from "./care-team.types";

const selectDomain = (state: any) => state.teamReducer;

export const team = createDraftSafeSelector(
  selectDomain,
  (team: IteamState) => team.team
);

export const singleteam = createDraftSafeSelector(
  selectDomain,
  (team: IteamState) => team.singleTeam
);
export const careTeam = createDraftSafeSelector(
  selectDomain,
  (team: IteamState) => team.careTeams
);

export const successMessage = createDraftSafeSelector(
  selectDomain,
  (team: IteamState) => team.teamSuccessMesssage
);

export const teamError = createDraftSafeSelector(
  selectDomain,
  (team: IteamState) => team.teamError
);

export const teamActivityInProcess = createDraftSafeSelector(
  selectDomain,
  (team: IteamState) => team.isTeamActivityInProcess
);


export const teamDeleteInProcess = createDraftSafeSelector(
  selectDomain,
  (team: IteamState) => team.isTeamDeleteInProcess
);
